import { useEffect, useState } from 'react';
import './UnityModelLoading.less';
export default function UnityModelLoading(props) {
  useEffect(() => {}, []);
  return (
    <div className="unity-model-loading">
      <div className="unity-model-loading-icon"></div>
    </div>
  );
}
